require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-activists-respond-to-misguided-economist-article-on.json") })
        }
      }, "path---en-us-update-activists-respond-to-misguided-economist-article-on");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-activists-respond-to-misguided-economist-article-on!./.cache/json/en-us-update-activists-respond-to-misguided-economist-article-on.json
// module id = 604
// module chunks = 231608221292675